export default "__VITE_ASSET___Wt0hbUF__"